import { useEffect } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { LOGIN_REDIRECT_URI } from "../../constants/environment";
import { getFromStorage } from "../../services/handleLocalStorage";
import { PREVIOUS_URL } from "../../constants/storage";

const Login = (): JSX.Element => {
  const { keycloak } = useKeycloak();

  const path = getFromStorage(PREVIOUS_URL) || "";
  useEffect(() => {
    keycloak?.login({
      redirectUri: `${LOGIN_REDIRECT_URI}${path.replace(/^\/|\/$/g, "")}`,
    });
  }, [keycloak, path]);

  return <div />;
};

export default Login;
